<template>
  <v-container class="cmpbk black--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "invite",
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },

    invite_in() {
      console.log("invite_in");

      this.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.news_media_subscribersIdsqr = parseInt(this.$route.query.i);

      formIn.apiname = "invite_in";

      let self = this;
      this.$store
        .dispatch("invite_in", formIn)
        .then((data) => {
          this.show_loader(false);

          this.swall_it(
            "Invite Status",
            "Success. You may now close this window.",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    init() {
      if (this.$route.query.i != null) {
        this.invite_in();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
